import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

interface ReleaseForRepickModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  numSelectedGroups: number;
}

export const ReleaseForRepickModal = memo(function ReleaseForRepickModal({
  isOpen,
  onClose,
  onConfirm,
  numSelectedGroups,
}: ReleaseForRepickModalProps) {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <RedoModal
      isOpen={isOpen}
      onModalCloseRequested={onClose}
      subtitle="This will remove the selected orders from their pick sessions and make them available to be picked again."
      title="Release for repick"
    >
      <Flex dir="column" gap="lg" w="full">
        <Text fontSize="sm" textColor="secondary">
          {numSelectedGroups === 1
            ? "1 order will be released for repick."
            : `${numSelectedGroups} orders will be released for repick.`}
        </Text>
        <Flex gap="lg" justify="flex-end" w="full">
          <RedoButton
            hierarchy="secondary"
            onClick={onClose}
            size="md"
            text="Cancel"
          />
          <RedoButton
            hierarchy="primary"
            onClick={handleConfirm}
            size="md"
            text="Release for repick"
          />
        </Flex>
      </Flex>
    </RedoModal>
  );
});
